import React from "react"
import { withRouter } from "react-router"
import { has } from "lodash"

import Header from "./DetailHeader"
import GameGallery from "./GameGallery"
import GameInfo from "./GameInfo"

import Error from "./../general/Error"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

class Detail extends React.Component{
    constructor(){
        super()
        this.state = {
            data: null,
            isLoading: true,
            error: ""
        }
    }
    componentDidMount(){
        const projectId = this.props.match.params.id;
        fetch(`/api/store/project/${projectId}/detail`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({
                data: data.result,
                isLoading: false
            })
        })
        .catch(data=>this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    toggleModal = () =>{
        this.setState(prevState => {
            return{
                modalOpen: !prevState.modalOpen
            }
        })
    }
    render(){
        if (this.state.error !== ""){
            return(
                <Error error={this.state.error} />
            )
        }
        return(
            <div className={this.state.isLoading === true? "loadingWrapper" : "mainContent"}>
                {this.state.isLoading === true
                ? <h3 className="loading"><FontAwesomeIcon icon={faSpinner} spin /></h3>
                : <>
                    <Header data={this.state.data}/>
                    {this.state.data.galleryUrls == null 
                        ? null 
                        : <GameGallery data={this.state.data} />}
                    <GameInfo data={this.state.data} toggleModal={this.toggleModal}/> 
                </>
                }
            </div>
        )
    }
}

export default withRouter(Detail)